import { render, staticRenderFns } from "./EditTrainingProgramButton.vue?vue&type=template&id=bb8ab36c&"
import script from "./EditTrainingProgramButton.vue?vue&type=script&lang=js&"
export * from "./EditTrainingProgramButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports